import { useState } from 'react';
import { Tag } from '@phosphor-icons/react';
import styles from './AddOnCard.module.scss';

export default function AddOnProductImage({
  imageRef,
  name,
}: Readonly<{ imageRef?: string; name: string }>) {
  const [showAddOnImage, setShowAddOnImage] = useState(Boolean(imageRef));

  return showAddOnImage ? (
    <img
      alt={name}
      className={styles.addOnThumb}
      onError={() => setShowAddOnImage(false)}
      src={imageRef}
    />
  ) : (
    <span className={styles.imagePlaceholder}>
      <Tag fill="var(--blue-grey-400)" height="40" width="40" weight="bold" />
    </span>
  );
}
